let pendingSignOut: Promise<void>|null = null;

// Firebase publishes the signed-out observer state before every continuation
// waiting on signOut() is guaranteed to run. During that short window the
// login screen is already interactive, so a new sign-in can otherwise be
// overtaken by the tail of the previous logout.
export const signOutWithBarrier = (auth: { signOut?: () => Promise<void> } | null | undefined) => {
  if (pendingSignOut) return pendingSignOut;

  let signOutResult: Promise<void> | undefined;
  try {
    signOutResult = auth?.signOut?.();
  } catch (error) {
    signOutResult = Promise.reject(error);
  }

  const operation = Promise.resolve(signOutResult);
  const trackedOperation = operation.finally(() => {
    if (pendingSignOut === trackedOperation) pendingSignOut = null;
  });
  pendingSignOut = trackedOperation;
  return trackedOperation;
};

export const waitForPendingSignOut = async () => {
  const operation = pendingSignOut;
  if (operation) await operation;
};

export const isSignOutPending = () => Boolean(pendingSignOut);
